import { useCallback, useState } from 'react';

const useModalState = ({ initialModalState = null } = {}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalData, setModalData] = useState(
    initialModalState ? initialModalState : null
  );

  const closeModal = useCallback(() => {
    setIsOpen(false);
    setModalData(null);
  }, []);

  const openModal = useCallback((data = null) => {
    setIsOpen(true);
    setModalData(data);
  }, []);

  return {
    isOpen,
    openModal,
    closeModal,
    modalData,
  };
};

export default useModalState;
